import React from 'react'
import { useTranslation } from 'react-i18next'

import { TableCell, TableRow } from '@mui/material'

import AcquiringDashboardViewModal from 'components/core/Acquiring/AcquiringCharges/components/AcquiringChargesViewModal/AcquiringChargesViewModal'
import { useStyles } from 'components/core/Acquiring/AcquiringCharges/components/styles'
import { ToggleView } from 'components/core/Acquiring/styles'
import { dateAndTimeToLocaleString, toLocaleStringWithCurrency } from 'utils/helperNumbersFormating'

interface RowProps {
    charge: ChargesRecord
}

const AcquiringChargesTableRow: React.FC<RowProps> = ({ charge }) => {
    const { t } = useTranslation(['override', 'translations', 'keys'])
    const classes = useStyles()

    return (
        <TableRow className={classes.root} hover>
            <TableCell align="left" component="th" scope="row" padding="normal">
                {dateAndTimeToLocaleString(charge.initiatedOn)}
            </TableCell>
            <TableCell align="left" component="th" scope="row" padding="normal">
                {charge.status}
            </TableCell>
            <TableCell align="left" component="th" scope="row" padding="normal">
                {toLocaleStringWithCurrency(charge?.amount?.value, charge?.amount?.currencyCode)}
            </TableCell>
            <TableCell align="right" component="th" scope="row" padding="normal">
                {charge.externalId}
            </TableCell>
            <TableCell align="right" component="th" scope="row" padding="normal">
                <AcquiringDashboardViewModal charge={charge}>
                    <ToggleView> {t('RecentTransactions.View')} </ToggleView>
                </AcquiringDashboardViewModal>
            </TableCell>
        </TableRow>
    )
}

export default AcquiringChargesTableRow
